import { AxiosRequestConfig } from 'axios';
import queryString from 'query-string';

import Client from './client';
import { Business, Result } from './types';

type Response = {
  readonly result: Result;
  readonly status: number;
  readonly results: Business[];
  readonly hasMore: boolean;
};

export default (
  latitude: number,
  longitude: number,
  page: number = 0,
  nearby: boolean = true,
  query?: string,
  config?: AxiosRequestConfig
) => {
  return Client.get<Response>(
    `/b/v1/businesses/suggest?${queryString.stringify({
      latitude,
      longitude,
      query,
      page,
      nearby,
    })}`,
    config
  );
};
